import React from "react";
import { Box } from "@mantine/core";
import { ReactComponent as Icon } from "../../assets/img/Epicc.svg";
import EhrConnect from "./Ehrconnect";
import { Paper,Space, } from "@mantine/core";



const Ehr: React.FC = ({}) => {
 const propsss = (
    <>
      EHR Type <span style={{ color: "red" }}>*</span>
    </>
  );


  return (
    <Box>
      <Space h="md" />
      <Paper
        sx={{
          borderRadius: "8px",
          marginLeft: "40px",
          marginRight: "40px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
      >
        
        <EhrConnect ehrorwear={propsss} wear={true} />
       
      </Paper>
    </Box>
  );
};

export default Ehr;
